export default "__VITE_ASSET__BakwUe47__"